/* eslint-disagit le prettier/prettier */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db, firebase, sendEmail } from 'firebase/fbConfig.js';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import _ from 'lodash';
import axios from 'axios'

import ReactTable from 'react-table';
import moment from 'moment';

import QuoteOrderForm from 'components/Forms/QuoteOrderForm';
import DispatchOrderForm from 'components/Forms/DispatchOrderForm.jsx';
import ShipFullScreenMap from '../Maps/ShipFullScreenMap';
import Chat from '../../components/Chat';
import EntryForm from 'components/Forms/CreateEntryForm';
import TaskCreator from 'components/Forms/TaskCreatorForm.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

import Button from 'components/CustomButtons/Button.jsx';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';

import styles from 'assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx';

import withStyles from '@material-ui/core/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import Slide from '@material-ui/core/Slide';
import TaskViewer from 'components/Tasks/TaskViewer.jsx';
import Modal from '@material-ui/core/Modal';
import QuoteSummary from './QuoteSummary';
import { Typography } from '@material-ui/core';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const registryColumns = [
  {
    Header: '',
    accessor: 'remove',
    sortable: false,
    filterable: false,
  },
  {
    Header: '',
    accessor: 'edit',
    sortable: false,
    filterable: false,
  },
  {
    Header: '$ Amount',
    accessor: 'dollarAmount',
  },
  {
    Header: 'Category',
    accessor: 'category',
  },
  {
    Header: 'Business',
    accessor: 'business',
  },
  {
    Header: 'Type',
    accessor: 'type',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Trip #',
    accessor: 'tripNumber',
  },
];

const paymentRegistryColumns = [
  {
    Header: '',
    accessor: 'remove',
    sortable: false,
    filterable: false,
  },
  {
    Header: '',
    accessor: 'edit',
    sortable: false,
    filterable: false,
  },
  {
    Header: '$ Amount',
    accessor: 'dollarAmount',
  },
  {
    Header: 'Check/ACH Number',
    accessor: 'checkACHNumber',
  },
  {
    Header: 'Deposit/Pay Date',
    accessor: 'date',
  },
  {
    Header: 'Invoice/Payment Date',
    accessor: 'receivedDate',
  },
  {
    Header: 'Category',
    accessor: 'category',
  },
  {
    Header: 'Business',
    accessor: 'business',
  },
  {
    Header: 'Type',
    accessor: 'type',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Settlement #',
    accessor: 'tripNumber',
  },
];


const tripColumns = [
  {
    Header: '',
    accessor: 'view',
    sortable: false,
    filterable: false,
  },
  {
    Header: '',
    accessor: 'rateCon',
    sortable: false,
    filterable: false,
  },
  {
    Header: 'Trip #',
    accessor: 'tripNumber',
  },
  {
    Header: 'Trip Type',
    accessor: 'status',
  },
  {
    Header: 'Vendor',
    accessor: 'vendorName',
  },
  {
    Header: 'Driver',
    accessor: 'driverName',
  },
  {
    Header: 'Orders',
    accessor: 'freightBillNumbers',
  },
  {
    Header: 'Pick Up Location',
    accessor: 'tripStartLocation',
  },
  {
    Header: 'Drop Off Location',
    accessor: 'tripEndLocation',
  },
  {
    Header: "Total Revenue",
    accessor: "totalRevenue"
  },
  {
    Header: "Total Expense",
    accessor: "totalExpenses"
  },
  {
    Header: "CM$",
    accessor: "cmTotal"
  },
];

const settlementColumns = [
  {
    Header: '',
    accessor: 'view',
    sortable: false,
    filterable: false,
  },
  {
    Header: 'Settlement #',
    accessor: 'tripNumber',
  },
  
  {
    Header: 'Orders',
    accessor: 'freightBillNumbers',
  },
  
  {
    Header: "Amount",
    accessor: "totalRevenue"
  }
];

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

class OrderDistinction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderID: window.location.pathname.split('/')[2],
      loaded: false,
      index: null,
      coordinates: {},
      editRegistry: false,
      totalRevenue: 0,
      totalExpenses: 0,
      cmTotal: 0,
      cmPercent: 0,
      chatOpen: false,
      addItemModal: false,
      summaryModal: false,
      snackMessage: '',
      snackSeverity: '',
    };
    this.chunk = 300
  }

  componentDidMount() {
    const setData = (status, coordinates, orderData) => {
      const statusToIndexMap = [
        'Pending pending Quoted quoted Quoted Needs Approval',
        'Booked booked Quote Declined Dispatched dispatched In Route to Shipper Arrived at Shipper Driver Departed Shipper Arrived at Airline Tendered to Airline Awaiting Departure Aircraft Departed Aircraft Arrived Aircraft Download In Route to Consignee Arrived at Consignee Docked Delivered Cancelled cancelled canceled Cancel Requested',
      ];
      const index = statusToIndexMap.indexOf(
        statusToIndexMap.find((statuses) => statuses.includes(status))
      );
      this.setState({
        loaded: true,
        index,
        coordinates,
        orderData,
      });
    };

    const getOrder = async () => {
      const orderSnap = await db
        .collection('haney-orders')
        .doc(this.state.orderID)
        .get();
      if (orderSnap.exists) {
        const orderData = {
          ...orderSnap.data(),
          id: orderSnap.id,
        };

        const {
          status,
          uid,
          originLat,
          originLng,
          destinationLat,
          destinationLng,
          dropOffDriverLocation,
        } = orderData;
        const origin = {
          lat: originLat,
          lng: originLng,
        };
        const destination = {
          lat: destinationLat,
          lng: destinationLng,
        };
        const driver = dropOffDriverLocation ? dropOffDriverLocation : null;
        setData(
          status,
          { origin, destination, driver },
          this.tripRowFromOrder(orderData)
        );

        const tripIDs = orderData.trips
          ? orderData.trips.map((trip) => trip.id)
          : [];

        const tripQuerySnaps = await Promise.all(tripIDs.map((id) => db.collection('haneyTrips').doc(id).get()));

        const tripsData = tripQuerySnaps.map((snapshot) => {

          if (snapshot.exists) {
            const docData = {
              ...snapshot.data(),
              id: snapshot.id
            }
            console.log('point1', docData);

            const LocationInfo = ({ type }) => {
              console.log('point99', docData, type);
              console.log(typeof docData[`table${type}Location`]);

              if (docData[`table${type}Location`] && typeof docData[`table${type}Location`] !== 'string') {
                let camelCase;
                if (type === 'Pickup' || type === 'PickUp') {
                  camelCase = 'PickUp';
                }
                if (type === 'DropOff') {
                  camelCase = 'DropOff';
                }

                console.log(docData[`table${camelCase}Location`]);


                const { businessName, address, city, state, zip } = docData[`table${camelCase}Location`];

                return <p>{[businessName, address, city, state, zip].filter(Boolean).join(' ')}</p>;
              }

              return <p>{docData[`table${type}Location`]}</p>;
            };

            docData.view = (
              <Link to={`/trips/${docData.id}`}>
                <Button color="primary" fullWidth>
                  VIEW
                </Button>
              </Link>
            );
            orderData.settlements && orderData.settlements.map((settlement, i) => (
              settlement.view = (
                <Link to={`/settlements/${settlement.id}`}>
                  <Button color="primary" fullWidth>
                    VIEW
                  </Button>
                </Link>
              )
            ))
            

            docData.rateCon = docData.rateConURL ? (
              <a href={docData.rateConURL} target="_blank">
                <Button color="info" fullWidth>
                  RATE CON
                </Button>
              </a>
            ) : (
              ''
            );

            docData.tripStartLocation = <LocationInfo type="Pickup" />;
            docData.tripEndLocation = <LocationInfo type="DropOff" />;

            return docData;
          } else {
            const docData = [{ none: 'none' }];
            return docData;
          }
        });

        this.setState({
          tripsData,
          orderData,
        });

        const registerObserver = db
          .collection('haney-orders')
          .doc(this.state.orderID)
          .collection('register')
          .onSnapshot((snapshot) => {
            // Get register data
            const data = [];
            for (let i = 0; i < snapshot.docs.length; i++) {
              const docData = {
                ...snapshot.docs[i].data(),
                id: snapshot.docs[i].id,
              };
              data.push(docData);
            }

            let totalRevenue = 0;
            let totalExpenses = 0;

            // Create array for table. Set conditions for changing totalRevenue and totalExpense
            const registerData = data.map((row, i) => {
              // Shorten description
              const dArray = row.description.split('');
              let d;
              if (dArray.length > 20) {
                d = `${dArray.slice(0, 20).join('')}...`;
              } else {
                d = row.description;
              }

              // Add to revenue or expenses
              if (row.category === 'revenue') {
                totalRevenue += parseFloat(row.dollarAmount);
              } else if (row.category === 'expense') {
                totalExpenses += parseFloat(row.dollarAmount);
              } else if (row.category === 'customer discount') {
                totalRevenue -= parseFloat(row.dollarAmount);
              } else if (row.category === 'vendor credit') {
                totalExpenses -= parseFloat(row.dollarAmount);
              }

              row.dollarAmount = row.dollarAmount.toFixed(2);

              return {
                ...row,
                remove: (
                  <Button
                    color="primary"
                    fullWidth
                    onClick={() => this.deleteRegistry(row)}
                  >
                    remove
                  </Button>
                ),
                edit: (
                  <Button
                    color="info"
                    fullWidth
                    onClick={() => this.updateRegistry(row)}
                  >
                    edit
                  </Button>
                ),
                dollarAmount: (
                  <p
                    style={{
                      color:
                        row.category === 'expense' ||
                          row.category === 'customer discount'
                          ? 'red'
                          : row.category === 'revenue' ||
                            row.category === 'vendor credit'
                            ? 'green'
                            : '',
                    }}
                  >
                    {row.dollarAmount}
                  </p>
                ),
                description: <p>{d}</p>,
                business: (
                  <p>
                    {row.business
                      ? row.business.businessName
                      : row.vendor
                        ? row.vendor.businessName
                        : ''}
                  </p>
                ),
              };
            });

            const cmTotal = totalRevenue - totalExpenses;
            const cmPercent = cmTotal / totalRevenue;

            if (
              totalRevenue.toString().includes('.') &&
              totalRevenue.toString().split('.')[1].length === 1
            ) {
              totalRevenue = `${totalRevenue}0`;
            } else if (!totalRevenue.toString().includes('.')) {
              totalRevenue = `${totalRevenue}.00`;
            }

            if (
              totalExpenses.toString().includes('.') &&
              totalExpenses.toString().split('.')[1].length === 1
            ) {
              totalExpenses = `${totalExpenses}0`;
            } else if (!totalExpenses.toString().includes('.')) {
              totalExpenses = `${totalExpenses}.00`;
            }

            this.setState({
              registerData,
              totalRevenue,
              totalExpenses,
              cmTotal,
              cmPercent,
            });
          });

        this.unsubscribe = registerObserver;

        const paymentsRegisterObserver = db
          .collection('haney-orders')
          .doc(this.state.orderID)
          .collection('paymentsRegister')
          .onSnapshot((snapshot) => {
            // Get register data
            const data = [];
            for (let i = 0; i < snapshot.docs.length; i++) {
              const docData = {
                ...snapshot.docs[i].data(),
                id: snapshot.docs[i].id,
              };
              data.push(docData);
            }

            let actualTotalRevenue = 0;
            let actualTotalExpenses = 0;

            // Create array for table. Set conditions for changing totalRevenue and totalExpense
            const paymentsRegisterData = data.map((row, i) => {
              // Shorten description
              const dArray = row.description.split('');
              let d;
              if (dArray.length > 20) {
                d = `${dArray.slice(0, 20).join('')}...`;
              } else {
                d = row.description;
              }

              // Add to revenue or expenses
              if (row.category === 'revenue') {
                actualTotalRevenue += parseFloat(row.dollarAmount);
              } else if (row.category === 'expense') {
                actualTotalExpenses += parseFloat(row.dollarAmount);
              } else if (row.category === 'customer discount') {
                actualTotalRevenue -= parseFloat(row.dollarAmount);
              } else if (row.category === 'vendor credit') {
                actualTotalExpenses -= parseFloat(row.dollarAmount);
              }

              row.dollarAmount = row.dollarAmount.toFixed(2);

              return {
                ...row,
                remove: (
                  <Button
                    color="primary"
                    fullWidth
                    onClick={() => this.deletePaymentsRegistry(row)}
                  >
                    remove
                  </Button>
                ),
                edit: (
                  <Button
                    color="info"
                    fullWidth
                    onClick={() => this.updatePaymentsRegistry(row)}
                  >
                    edit
                  </Button>
                ),
                dollarAmount: (
                  <p
                    style={{
                      color:
                        row.category === 'expense' ||
                          row.category === 'customer discount'
                          ? 'red'
                          : row.category === 'revenue' ||
                            row.category === 'vendor credit'
                            ? 'green'
                            : '',
                    }}
                  >
                    {row.dollarAmount}
                  </p>
                ),
                date: row.date ? row.date.toDate().toString() : "",
                receivedDate: row.receivedDate ? row.receivedDate.toDate().toString() : "",
                description: <p>{d}</p>,
                business: (
                  <p>
                    {row.business
                      ? row.business.businessName
                      : row.vendor
                        ? row.vendor.businessName
                        : ''}
                  </p>
                ),
              };
            });

            const actualCmTotal = actualTotalRevenue - actualTotalExpenses;
            const actualCmPercent = actualCmTotal / actualTotalRevenue;

            if (
              actualTotalRevenue.toString().includes('.') &&
              actualTotalRevenue.toString().split('.')[1].length === 1
            ) {
              actualTotalRevenue = `${actualTotalRevenue}0`;
            } else if (!actualTotalRevenue.toString().includes('.')) {
              actualTotalRevenue = `${actualTotalRevenue}.00`;
            }

            if (
              actualTotalExpenses.toString().includes('.') &&
              actualTotalExpenses.toString().split('.')[1].length === 1
            ) {
              actualTotalExpenses = `${actualTotalExpenses}0`;
            } else if (!actualTotalExpenses.toString().includes('.')) {
              actualTotalExpenses = `${actualTotalExpenses}.00`;
            }

            this.setState({
              paymentsRegisterData,
              actualTotalRevenue,
              actualTotalExpenses,
              actualCmTotal,
              actualCmPercent,
            });
          });

        this.unsubscribe = paymentsRegisterObserver;

        const statusObserver = db
          .collection('haney-orders')
          .doc(this.state.orderID)
          .collection('statusLogs')
          .orderBy('updatedAt')
          .onSnapshot((snapshot) => {
            // Get register data
            const data = [];
            for (let i = 0; i < snapshot.docs.length; i++) {
              const docData = {
                ...snapshot.docs[i].data(),
                id: snapshot.docs[i].id,
              };
              data.push(docData);
            }

            this.setState({
              statusLogsData: data,
            });
          });

        this.unsubscribe = statusObserver;
      }
    };

    getOrder();
  }

  tripRowFromOrder = (order) => ({
    id: order.id,
    billingParty: order.billingParty ? order.billingParty : '',
    freightBillNumber: order.freightBillNumber
      ? order.freightBillNumber
      : 'N/A',
    originBusinessName: order.origin.businessName
      ? order.origin.businessName
      : '',
    originCity:
      order.origin.city && order.origin.state
        ? order.origin.city + ', ' + order.origin.state
        : '',
    originState: order.originState ? order.originState : '',
    destinationBusinessName: order.destination.businessName
      ? order.destination.businessName
      : '',
    destinationCity:
      order.destination.city && order.destination.state
        ? order.destination.city + ', ' + order.destination.state
        : '',
    destinationState: order.destinationState ? order.destinationState : '',
    uid: order.uid ? order.uid : 'N/A',
    deliveryType: order.deliveryType ? order.deliveryType : 'N/A',
    origin: order.originZip ? order.originZip : 'N/A',
    pickUpDate: order.origin.date
      ? moment(order.origin.date.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    destination: order.destinationZip ? order.destinationZip : 'N/A',
    dropOffDate: order.destination.date
      ? moment(order.destination.date.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    class: order.class ? order.class : 'N/A',
    submitted: order.updatedAt
      ? moment(order.updatedAt.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    status: order.status ? order.status : 'N/A',
    financialStatus: order.financialStatus ? order.financialStatus : 'N/A',
    pickUpRateStatus: order.pickUpRateStatus ? order.pickUpRateStatus : 'N/A',
    dropOffRateStatus: order.dropOffRateStatus
      ? order.dropOffRateStatus
      : 'N/A',
    updatedAt: order.updatedAt
      ? moment(order.updatedAt.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    serviceETA: order.serviceETA
      ? moment(order.serviceETA.toDate()).format('MM/DD/YYYY')
      : 'N/A',
    entityIDs: order.entityIDs ? order.entityIDs : [],
    vendorName:
      order.vendorPickUp && order.vendorPickUp.name
        ? order.vendorPickUp.name
        : 'N/A',
    driverName:
      order.pickUpDriver && order.pickUpDriver.firstName
        ? `${order.pickUpDriver.firstName}${order.pickUpDriver.lastName ? ` ${order.pickUpDriver.lastName}` : ''
        }`
        : 'N/A',
    signingURLs: order.signingURLs,
  });

  trimCities = async () => {
    const snapshotsArr = await Promise.all([
      db.collection('haney-shippers').get(),
      db.collection('haney-vendors').get(),
    ]);
    const [shipperSnapshot, vendorSnapshot] = snapshotsArr;

    const promises = [];

    const determinePromises = (docs, collection, index = 0) => {
      if (docs.length > index) {
        const docData = {
          ...docs[index].data(),
          id: docs[index].id,
        };

        if (docData.name && docData.name !== docData.name.trim()) {
          promises.push(
            db
              .collection(collection)
              .doc(docData.id)
              .set({ name: docData.name.trim() }, { merge: true })
          );
        }

        return determinePromises(docs, collection, ++index);
      }
    };

    determinePromises(shipperSnapshot.docs, 'haney-shippers');
    determinePromises(vendorSnapshot.docs, 'haney-vendors');

    const responses = await Promise.all(promises);
    console.log(responses);
    console.log('All done');
  };

  refreshFinancials = async () => {
    const ordersSnapshot = await db
      .collection('haney-orders')
      .get();
    const findPromises = [];
    const registerRefs = [];

    for (let i = 0; i < ordersSnapshot.docs.length; i++) {
      const rSnapshot = ordersSnapshot.docs[i];
      const rData = {
        ...rSnapshot.data(),
        id: rSnapshot.id,
      };

      const registersSnapshot = await db.collection('haney-orders').doc(rData.id).collection('register').get();

      console.log(rData.id)
      // const path = rSnapshot.ref.path.split('/');

      let totalRevenue = 0;
      let totalExpenses = 0;

      for (let i = 0; i < registersSnapshot.docs.length; i++) {
        const docData = {
          ...registersSnapshot.docs[i].data(),
          id: registersSnapshot.docs[i].id
        };

        if (docData.category === 'revenue') {
          totalRevenue += Number(docData.dollarAmount);
        } else if (docData.category === 'expense') {
          totalExpenses += Number(docData.dollarAmount);
        } else if (docData.category === 'customer discount') {
          totalRevenue -= Number(docData.dollarAmount);
        } else if (docData.category === 'vendor credit') {
          totalExpenses -= Number(docData.dollarAmount);
        }

      }


      console.log(totalRevenue, totalExpenses);
      db.collection('haney-orders').doc(rData.id).set(
        {
          totalRevenue: totalRevenue,
          totalExpenses: totalExpenses
        },
        { merge: true }
      )

    }

  }

  dynamicModeNameToSubDeliveryType = async () => {
    const ordersSnapshot = await db.collection('haney-orders').get();
    const ordersToUpdate = [];

    for (let i = 0; i < ordersSnapshot.docs.length; i++) {
      const orderDoc = ordersSnapshot.docs[i];
      const orderData = {
        ...orderDoc.data(),
        id: orderDoc.id,
      };

      if (orderData.dynamicModeName && !orderData.subDeliveryType) {
        ordersToUpdate.push(
          orderDoc.ref.set(
            { subDeliveryType: orderData.dynamicModeName },
            { merge: true }
          )
        );
      }
    }

    Promise.all(ordersToUpdate).then((responses) => {
      console.log(responses);
      console.log('All done');
    });
  };

  reformatAirCarrierExpense = async () => {
    const registersSnapshot = await db
      .collectionGroup('register')
      .where('type', '==', 'air carrier expense')
      .get();
    const findPromises = [];
    const registerRefs = [];

    for (let i = 0; i < registersSnapshot.docs.length; i++) {
      const rSnapshot = registersSnapshot.docs[i];
      const rData = {
        ...rSnapshot.data(),
        id: rSnapshot.id,
      };
      const path = rSnapshot['$c'].path.segments;

      if (!rData.business.businessName && !rData.business.id) {
        const orderRef = db.collection('haney-orders').doc(path[6]);
        console.log(path[6], path[8]);
        findPromises.push(orderRef.get());
        registerRefs.push(orderRef.collection('register').doc(path[8]));
      }
    }

    const orderResponses = await Promise.all(findPromises);
    console.log(orderResponses);
    const setPromises = [];

    for (let i = 0; i < orderResponses.length; i++) {
      const orderData = {
        ...orderResponses[i].data(),
        id: orderResponses[i].id,
      };

      console.log(orderData);

      if (
        orderData.originAirlineDetails &&
        orderData.originAirlineDetails.length &&
        orderData.test
      ) {
        const vendorData = orderData.originAirlineDetails[0];

        console.log({
          businessName: vendorData.name,
          id: vendorData.id,
        });

        setPromises.push(
          registerRefs[i].set(
            {
              business: {
                businessName: vendorData.name,
                id: vendorData.id,
              },
            },
            { merge: true }
          )
        );
      }
    }

    const setResponses = await Promise.all(setPromises);
    console.log(setResponses);
    console.log('All done');
  };

  driverRefresh = async () => {
    const usersSnapshot = await db.collection('TEST-users').get();
    const emailsToSend = [];
    for (let i = 0; i < usersSnapshot.docs.length; i++) {
      const userData = {
        ...usersSnapshot.docs[i].data(),
        id: usersSnapshot.docs[i].id,
      };

      if (userData.email) {
        const subject = `Please refresh your CargoRx application`;
        const html = `<pThis weekend the CargoRx platform recently migrated cloud providers. Please refresh your application to update to the latest version.</p><p>Thank you.</p>`;
        const emails = [userData.email];

        emailsToSend.push(
          sendEmail({
            emails,
            subject,
            html,
          })
        );
      }
    }

    Promise.all(emailsToSend).then((responses) => {
      console.log(responses);
      console.log('All Done!');
    });
  };

  calculateAllOrdersRevenuesAndExpenses = async () => {
    const ordersRef = db.collection('haney-orders');
    const allOrders = await ordersRef.get();

    // Loop to get array of Promises. Promises to get register data from individual order. Also build array at same index for references to that order
    const orderRefs = [];
    const registersPromises = [];
    for (let i = 0; i < allOrders.docs.length; i++) {
      const orderData = {
        ...allOrders.docs[i].data(),
        id: allOrders.docs[i].id,
      };

      // if (orderData.test) continue;

      const orderRef = ordersRef.doc(orderData.id);
      const registerRef = orderRef.collection('register');

      orderRefs.push(orderRef);
      registersPromises.push(registerRef.get());
    }

    // Get all the registers
    const ordersRegistersSnapshot = await Promise.all(registersPromises);

    // Loop through registers to figure total revenue and expenses on individual orders. Create array of promises to set orders totalRevenue and totalExpenses appropriately
    const orderPromises = [];
    for (let i = 0; i < ordersRegistersSnapshot.length; i++) {
      let totalRevenue = 0;
      let totalExpenses = 0;
      for (let j = 0; j < ordersRegistersSnapshot[i].docs.length; j++) {
        const registerData = ordersRegistersSnapshot[i].docs[j].data();

        if (registerData.category === 'revenue') {
          totalRevenue += registerData.dollarAmount;
        } else if (registerData.category === 'expense') {
          totalExpenses += registerData.dollarAmount;
        } else if (registerData.category === 'customer discount') {
          totalRevenue -= registerData.dollarAmount;
        } else if (registerData.category === 'vendor credit') {
          totalExpenses -= registerData.dollarAmount;
        }
      }

      orderPromises.push(
        orderRefs[i].set(
          {
            totalRevenue,
            totalExpenses,
          },
          { merge: true }
        )
      );
    }

    // Resolve all promised order data changed
    Promise.all(orderPromises).then((responses) => {
      console.log(responses);
      console.log('Finished :)');
    });
  };

  addLTLRevenuesAndExpenses = () => {
    const ordersRef = db.collection('haney-orders');
    ordersRef
      .where('deliveryType', '==', 'LTL')
      .get()
      .then(async (snapshot) => {
        const orders = snapshot.docs;
        const promises = [];
        for (let i = 0; i < orders.length; i++) {
          const orderData = {
            ...orders[i].data(),
            id: orders[i].id,
          };

          // if (orderData.test) continue;

          console.log(orderData.id);

          const expenses = [];

          const dollarAmount = parseFloat(orderData.autoLtlQuote);
          const business = {
            businessName: 'Accufrate',
            id: '86AEyQZ7ODbjgSt3PMW0',
          };
          orderData.vendorRate &&
            expenses.push({
              dollarAmount: parseFloat(orderData.vendorRate),
              type: 'accufrate rate',
              category: 'expense',
              description: 'Routing expense',
              business: business,
            });

          orderData.brokerRate &&
            expenses.push({
              dollarAmount: parseFloat(orderData.brokerRate),
              type: 'broker rate',
              category: 'expense',
              description: 'Routing expense',
              business: business,
            });

          orderData.insuranceCost &&
            expenses.push({
              dollarAmount: parseFloat(orderData.insuranceCost),
              type: 'insurance cost',
              category: 'expense',
              description: 'Routing expense',
              business: business,
            });

          const registerRef = ordersRef
            .doc(orderData.id)
            .collection('register');
          const register = await registerRef.get();
          const newRegistries = [
            ...expenses,
            {
              description: 'Initial revenue',
              dollarAmount: dollarAmount,
              type: 'quote approved',
              category: 'revenue',
              business: business,
            },
          ];
          for (let j = 0; j < newRegistries.length; j++) {
            let registryExists = false;
            let updateNotAdd = false;

            for (let k = 0; k < register.docs.length; k++) {
              const rData = register.docs[k].data();

              if (rData.type === newRegistries[j].type) {
                updateNotAdd = true;
                promises.push(
                  registerRef.doc(register.docs[k].id).set(newRegistries[j])
                );
                break;
              }

              if (_.isEqual(rData, newRegistries[j])) {
                registryExists = true;
                break;
              }
            }

            if (!registryExists && !updateNotAdd) {
              promises.push(registerRef.add(newRegistries[j]));
            }
          }
        }

        return promises;
      })
      .then((promises) => {
        Promise.all(promises).then((responses) => {
          console.log(responses);
        });
      });
  };

  moveTripsToRoot = () => new Promise((resolve, reject) => {
    db.collectionGroup('haney-trips').orderBy('tripNumber').get()
      .then(async snapshot => {
        const trips = snapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id
        }));


        for (let i = 0; i < Math.ceil(trips.length / this.chunk); i++) {
          const responses = await Promise.all(
            trips.slice(i * this.chunk, (i + 1) * this.chunk).map(data => {
              const { id, ...trip } = data;
              return db.collection('haneyTrips').doc(id).set(trip, { merge: true });
            })

          );
          console.log(responses);
        }

        resolve(true);
      })
  })

  deleteBadTrips = () => new Promise((resolve, reject) => {
    db.collection('haneyTrips').get()
      .then(snapshot => {
        console.log(snapshot)
        const remPromises = [];
        snapshot.docs.map(doc => {
          const docData = doc.data();

          if (!docData.orders) {
            remPromises.push(db.collection('haneyTrips').doc(doc.id).delete());
            console.log(doc.id, docData)
          };
        });

        // return;
        return Promise.all(remPromises);
      })
      .then(resolve)
      .catch(reject);
  })

  addOrderIDsToTrip = () => new Promise((resolve, reject) => {
    db.collection('haneyTrips').get()
      .then(async snapshots => {
        const trips = snapshots.docs.map(doc => {
          const docData = doc.data();

          console.log(docData.orders, doc.id);
          const orderIDs = Object.fromEntries(docData.orders.map(order => [order.orderID, true]))

          return {
            ...docData,
            id: doc.id,
            orderIDs
          }
        });

        for (let i = 0; i < Math.ceil(trips.length / this.chunk); i++) {
          const responses = await Promise.all(
            trips.slice(i * this.chunk, (i + 1) * this.chunk).map(trip => db.collection('haneyTrips').doc(trip.id).set({
              orderIDs: trip.orderIDs
            }, { merge: true }))
          );
          console.log(responses);
        }
        return
      })
      .then(resolve)
      .catch(reject);
  })

  addFinancialsToTripOrders = () => new Promise((resolve, reject) => {
    db.collection('haneyTrips').get()
      .then(snapshots => {
        const trips = snapshots.docs.map(doc => ({
          ...doc.data(),
          id: doc.id
        }));

        db.collection('haney-orders').get()
          .then(async snapshot => {
            const ordersObj = Object.fromEntries(
              snapshot.docs.map(doc => [
                doc.id,
                doc.data()
              ])
            )

            for (let i = 0; i < trips.length; i++) {
              for (let j = 0; j < trips[i].orders.length; j++) {
                trips[i].orders[j].totalRevenue = ordersObj[trips[i].orders[j].orderID].totalRevenue ? ordersObj[trips[i].orders[j].orderID].totalRevenue : 0;
                trips[i].orders[j].totalExpenses = ordersObj[trips[i].orders[j].orderID].totalExpenses ? ordersObj[trips[i].orders[j].orderID].totalExpenses : 0;
              }
            }

            for (let i = 0; i < Math.ceil(trips.length / this.chunk); i++) {
              const responses = await Promise.all(
                trips.slice(i * this.chunk, (i + 1) * this.chunk).map((trip) => {
                  console.log(trip.id, trip.orders);
                  db.collection('haneyTrips').doc(trip.id).set({
                    orders: trip.orders
                  }, { merge: true })
                })
              );
              console.log(responses);
            }
            return true
          })
          .then(resolve)
          .catch(reject)
      })
  })

  moveTrips = () => {
    // this.moveTripsToRoot()
    //   .then(_ => this.deleteBadTrips())
    //   .then(_ => this.addOrderIDsToTrip())
    this.addOrderIDsToTrip()
      .then(_ => this.addFinancialsToTripOrders())
      .then(_ => console.log('ok'))
      .catch(err => console.error(err));
  }

  changeAccountingInfo = async () => {
    const promises = [];

    // const registerRef = db.collection('haney-orders').doc(this.state.orderID).collection('register')
    // registerRef.get()
    //   .then(async snapshot => {
    //     for (let j = 0; j < snapshot.docs.length; j++) {
    //       const oldRegistry = {
    //         ...snapshot.docs[j].data(),
    //         id: snapshot.docs[j].id
    //       }

    //       promises.push(registerRef.doc(oldRegistry.id).set({
    //         category: oldRegistry.category ? oldRegistry.category : oldRegistry.type,
    //         type: oldRegistry.terms ? oldRegistry.terms : ( (oldRegistry.type && ['revenue', 'expense'].includes(oldRegistry.type)) ? '' : oldRegistry.type),
    //         dollarAmount: oldRegistry.dollarAmount,
    //         description: oldRegistry.description,
    //         business: oldRegistry.business
    //       }))
    //     }

    //     Promise.all(promises)
    //       .then(responses => {
    //         console.log(responses);
    //         console.log("All accounting changes done");
    //       })
    //   })

    const allOrdersRef = db.collection('haney-orders');

    allOrdersRef.get().then(async (ordersSnapshot) => {
      for (let i = 0; i < ordersSnapshot.docs.length; i++) {
        const orderData = {
          ...ordersSnapshot.docs[i].data(),
          id: ordersSnapshot.docs[i].id,
        };
        console.log(orderData);
        if (orderData.test) continue;

        const accountingRef = allOrdersRef
          .doc(orderData.id)
          .collection('register');

        const registries = await accountingRef.get();

        for (let j = 0; j < registries.docs.length; j++) {
          const oldRegistry = {
            ...registries.docs[j].data(),
            id: registries.docs[j].id,
          };

          promises.push(
            accountingRef.doc(oldRegistry.id).set({
              category: oldRegistry.category
                ? oldRegistry.category
                : oldRegistry.type,
              type: oldRegistry.terms
                ? oldRegistry.terms
                : oldRegistry.type &&
                  ['revenue', 'expense'].includes(oldRegistry.type)
                  ? ''
                  : oldRegistry.type,
              dollarAmount: oldRegistry.dollarAmount,
              description: oldRegistry.description,
              business: oldRegistry.business ? oldRegistry.business : ' ',
            })
          );
        }
      }

      Promise.all(promises).then((responses) => {
        console.log(responses);
        console.log('All accounting changes done');
      });
    });
  };

  checkRev = async () => {
    const promises = [];

    const allOrdersRef = db.collection('TEST-orders');

    allOrdersRef.get().then(async (ordersSnapshot) => {
      let orders = [];

      for (let i = 0; i < ordersSnapshot.docs.length; i++) {
        const orderData = {
          ...ordersSnapshot.docs[i].data(),
          id: ordersSnapshot.docs[i].id,
        };
        console.log(orderData);
        // orders[orderData.freightBillNumber] = {}
        // orders[orderData.freightBillNumber].origTotalRevenue = orderData.totalRevenue
        // orders[orderData.freightBillNumber].origTotalExpenses = orderData.totalExpenses
        // if (orderData.test) continue;

        const accountingRef = allOrdersRef
          .doc(orderData.id)
          .collection('register');

        const registries = await accountingRef.get();

        let totalRevenue = 0;
        let totalExpenses = 0;

        for (let i = 0; i < registries.docs.length; i++) {
          const docData = {
            ...registries.docs[i].data(),
            id: registries.docs[i].id,
          };

          if (docData.category === 'revenue') {
            totalRevenue += docData.dollarAmount;
          } else if (docData.category === 'expense') {
            totalExpenses += docData.dollarAmount;
          } else if (docData.category === 'customer discount') {
            totalRevenue -= docData.dollarAmount;
          } else if (docData.category === 'vendor credit') {
            totalExpenses -= docData.dollarAmount;
          } else {
            null;
          }
        }

        // orders[orderData.freightBillNumber].newTotalRevenue = totalRevenue
        // orders[orderData.freightBillNumber].newTotalExpenses = totalExpenses

        orders.push({
          freightBillNumber: orderData.freightBillNumber,
          origTotalRevenue: orderData.totalRevenue ? orderData.totalRevenue : 0,
          origTotalExpenses: orderData.totalExpenses
            ? orderData.totalExpenses
            : 0,
          newTotalRevenue: totalRevenue,
          newTotalExpenses: totalExpenses,
        });

        // for (let j = 0; j < registries.docs.length; j++) {
        //   const oldRegistry = {
        //     ...registries.docs[j].data(),
        //     id: registries.docs[j].id
        //   }

        // promises.push(accountingRef.doc(oldRegistry.id).set({
        //   category: oldRegistry.category ? oldRegistry.category : oldRegistry.type,
        //   type: oldRegistry.terms ? oldRegistry.terms : ((oldRegistry.type && ['revenue', 'expense'].includes(oldRegistry.type)) ? '' : oldRegistry.type),
        //   dollarAmount: oldRegistry.dollarAmount,
        //   description: oldRegistry.description,
        //   business: (oldRegistry.business ? oldRegistry.business : " ")
        // }))
        // }
      }
      console.log(
        orders.filter(function (order) {
          return (
            order.origTotalRevenue == order.newTotalRevenue ||
            order.origTotalExpenses == order.newTotalExpenses
          );
        })
      );
      // var qualifiedPickUpVendorsFinal = this.state.qualifiedPickUpVendors.filter(function (vendor) {
      //   // console.log(vendor.airCodes.indexOf(airport.icao))
      //   return !this[vendor.id] && (this[vendor.id] = true);
      // });
      // Promise.all(promises)
      //   .then(responses => {
      //     console.log(responses);
      //     console.log("All accounting changes done");
      //   })
    });
  };
  openChat = () => {
    this.setState({
      chatOpen: !this.state.chatOpen,
    });
  };
  chatClose = () => {
    this.setState({
      chatOpen: !this.state.chatOpen,
    });
  };
  addEstimatedItemOpen = () => {
    this.setState({
      addEstimatedItemModal: !this.state.addEstimatedItemModal,
    });
  };
  addActualItemOpen = () => {
    this.setState({
      addActualItemModal: !this.state.addActualItemModal,
    });
  };
  summaryModalOpen = () => {
    this.setState({
      summaryModal: true,
    });
  };
  addEstimatedItemClose = () => {
    this.setState({
      addEstimatedItemModal: false,
    });
  };
  addActualItemClose = () => {
    this.setState({
      addActualItemModal: false,
    });
  };
  summaryModalClose = () => {
    this.setState({
      summaryModal: false,
    });
  };

  handleClose = () => {
    this.setState({ editRegistry: false });
  };

  handlePaymentsClose = () => {
    this.setState({ editPaymentsRegistry: false });
  };

  updateRegistry = (r) => {
    this.setState({
      editRegistry: true,
      registry: r,
    });
  };

  updatePaymentsRegistry = (r) => {
    this.setState({
      editPaymentsRegistry: true,
      paymentsRegistry: r,
    });
  };

  deleteRegistry = (r) => {
    db.collection('haney-orders')
      .doc(this.state.orderID)
      .collection('register')
      .doc(r.id)
      .delete();
  };

  deletePaymentsRegistry = (r) => {
    db.collection('haney-orders')
      .doc(this.state.orderID)
      .collection('paymentsRegister')
      .doc(r.id)
      .delete();
  };

  setData = (status, coordinates, orderData) => {
    const statusToIndexMap = [
      'Pending pending Quoted quoted Quoted Needs Approval',
      'Booked booked Quote Declined Dispatched dispatched In Route to Shipper Arrived at Shipper Driver Departed Shipper Arrived at Airline Tendered to Airline Awaiting Departure Aircraft Departed Aircraft Arrived Aircraft Download In Route to Consignee Arrived at Consignee Docked Delivered Cancelled cancelled canceled Cancel Requested',
    ];
    const index = statusToIndexMap.indexOf(
      statusToIndexMap.find((statuses) => statuses.includes(status))
    );
    this.setState({
      loaded: true,
      index,
      coordinates,
      orderData,
    });
  };

  getCRXOrder = async () => {
    const orderSnap = await db
      .collection('TEST-orders')
      .doc(this.state.orderID)
      .get();
    if (orderSnap.exists) {
      const orderData = {
        ...orderSnap.data(),
        id: orderSnap.id,
      };

      const {
        status,
        uid,
        originLat,
        originLng,
        destinationLat,
        destinationLng,
        dropOffDriverLocation,
      } = orderData;
      const origin = {
        lat: originLat,
        lng: originLng,
      };
      const destination = {
        lat: destinationLat,
        lng: destinationLng,
      };
      const driver = dropOffDriverLocation ? dropOffDriverLocation : null;
      this.setData(
        status,
        { origin, destination, driver },
        this.tripRowFromOrder(orderData)
      );
      console.log;
      const tripIDs = orderData.trips
        ? orderData.trips.map((trip) => trip.id)
        : [];

      const tripQueries = tripIDs.map((id) =>
        db.collectionGroup('trips').where('id', '==', id)
      );
      const tripQuerySnaps = await Promise.all(
        tripQueries.map((query) => query.get())
      );

      const tripsData = tripQuerySnaps.map((qSnap) => {
        const docData = {
          ...qSnap.docs[0].data(),
          id: qSnap.docs[0].id,
        };

        docData.view = (
          <Link to={`/trips/${docData.id}`}>
            <Button color="primary" fullWidth>
              VIEW
            </Button>
          </Link>
        );

        docData.rateCon = docData.rateConURL ? (
          <a href={docData.rateConURL} target="_blank">
            <Button color="info" fullWidth>
              RATE CON
            </Button>
          </a>
        ) : (
          ''
        );

        return docData;
      });

      this.setState({
        crxTripsData: tripsData,
        crxOrderData: orderData,
      });

      const registerObserver = db
        .collection('TEST-orders')
        .doc(this.state.orderID)
        .collection('register')
        .onSnapshot((snapshot) => {
          // Get register data
          const data = [];
          for (let i = 0; i < snapshot.docs.length; i++) {
            const docData = {
              ...snapshot.docs[i].data(),
              id: snapshot.docs[i].id,
            };
            data.push(docData);
          }

          let totalRevenue = 0;
          let totalExpenses = 0;

          // Create array for table. Set conditions for changing totalRevenue and totalExpense
          const registerData = data.map((row, i) => {
            // Shorten description
            const dArray = row.description.split('');
            let d;
            if (dArray.length > 20) {
              d = `${dArray.slice(0, 20).join('')}...`;
            } else {
              d = row.description;
            }

            // Add to revenue or expenses
            if (row.category === 'revenue') {
              totalRevenue += parseFloat(row.dollarAmount);
            } else if (row.category === 'expense') {
              totalExpenses += parseFloat(row.dollarAmount);
            } else if (row.category === 'customer discount') {
              totalRevenue -= parseFloat(row.dollarAmount);
            } else if (row.category === 'vendor credit') {
              totalExpenses -= parseFloat(row.dollarAmount);
            }

            if (
              row.dollarAmount.toString().includes('.') &&
              row.dollarAmount.toString().split('.')[1].length === 1
            ) {
              row.dollarAmount = `${row.dollarAmount}0`;
            } else if (!row.dollarAmount.toString().includes('.')) {
              row.dollarAmount = `${row.dollarAmount}.00`;
            }

            return {
              ...row,
              remove: (
                <Button
                  color="primary"
                  fullWidth
                  onClick={() => this.deleteRegistry(row)}
                >
                  remove
                </Button>
              ),
              edit: (
                <Button
                  color="info"
                  fullWidth
                  onClick={() => this.updateRegistry(row)}
                >
                  edit
                </Button>
              ),
              dollarAmount: (
                <p
                  style={{
                    color:
                      row.category === 'expense' ||
                        row.category === 'customer discount'
                        ? 'red'
                        : row.category === 'revenue' ||
                          row.category === 'vendor credit'
                          ? 'green'
                          : '',
                  }}
                >
                  {row.dollarAmount}
                </p>
              ),
              description: <p>{d}</p>,
              business: (
                <p>
                  {row.business
                    ? row.business.businessName
                    : row.vendor
                      ? row.vendor.businessName
                      : ''}
                </p>
              ),
            };
          });

          const cmTotal = totalRevenue - totalExpenses;
          const cmPercent = cmTotal / totalRevenue;  // cmPercent= CM$

          if (
            totalRevenue.toString().includes('.') &&
            totalRevenue.toString().split('.')[1].length === 1
          ) {
            totalRevenue = `${totalRevenue}0`;
          } else if (!totalRevenue.toString().includes('.')) {
            totalRevenue = `${totalRevenue}.00`;
          }

          if (
            totalExpenses.toString().includes('.') &&
            totalExpenses.toString().split('.')[1].length === 1
          ) {
            totalExpenses = `${totalExpenses}0`;
          } else if (!totalExpenses.toString().includes('.')) {
            totalExpenses = `${totalExpenses}.00`;
          }

          this.setState({
            crxRegisterData: registerData,
            crxTotalRevenue: totalRevenue,
            crxTotalExpenses: totalExpenses,
            crxCmTotal: cmTotal,
            crxCmTotal: cmPercent,
            crxDataLoaded: true,
          });
        });

      this.unsubscribe = registerObserver;
    }
  };

  getTracker = () => {
    navigator.clipboard.writeText(`https://cargo-rx.web.app/pages/orders/${this.state.orderID}`);
    this.setState({ 
      snackMessage: 'Link has been copied to your clipboard',
      snackSeverity: 'info'
    })
  }

  loadKeepTruckin = () => {
    this.setState({
      ktLoaded: true
    })
    console.log("loadingKt")
    let vehicles = []
    let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=1`
    axios.get(
      url,
      {
        "headers": {
          "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
        }
      }
    ).then((response) => {
      // add truck location to accumulator
      console.log(response.data.vehicles)
      //   const location = response.data.vehicles[0].vehicle.current_location
      //   let truck = {
      //     truckLocation: {
      //       lat: location.lat,
      //       lng: location.lon
      //     }
      //   }
      Array.prototype.push.apply(vehicles, response.data.vehicles);

      let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=2`
      axios.get(
        url,
        {
          "headers": {
            "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
          }
        }
      ).then((response) => {
        // add truck location to accumulator
        // console.log(response.data.vehicles)
        //   const location = response.data.vehicles[0].vehicle.current_location
        //   let truck = {
        //     truckLocation: {
        //       lat: location.lat,
        //       lng: location.lon
        //     }
        //   }
        Array.prototype.push.apply(vehicles, response.data.vehicles);
        let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=3`
        axios.get(
          url,
          {
            "headers": {
              "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
            }
          }
        ).then((response) => {
          // add truck location to accumulator
          // console.log(response.data.vehicles)
          //   const location = response.data.vehicles[0].vehicle.current_location
          //   let truck = {
          //     truckLocation: {
          //       lat: location.lat,
          //       lng: location.lon
          //     }
          //   }
          Array.prototype.push.apply(vehicles, response.data.vehicles);
          // console.log(vehicles)
          this.setState({
            vehicles: vehicles,
            vehiclesReady: true
          })


        })
          .catch((error) => {
            console.log(error)
          })

      })
        .catch((error) => {
          console.log(error)
        })

    })
      .catch((error) => {
        console.log(error)
      })

  }

  loadPickUpDriverContact = (id) => {
    // console.log("loading order data")
    let data = db
      .collection('TEST-users')
      .doc(id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              ...docData,
              id: snapshot.id,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        this.setState({
          pickUpDriverContact: docObj,
          pickUpDriverContactLoaded: true,
        });
      });
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  filterVehicles = () => {
    console.log("vehicles " + this.state.vehicles)
    console.log("pickUpDriverContact" + this.state.pickUpDriverContact)
    let driverTruckNumber = this.state.pickUpDriverContact.truckNumber
    var filteredVehicles = this.state.vehicles.filter(function (el) {
      return el.vehicle.id == driverTruckNumber
    }
    )
    // console.log(filteredVehicles)

    this.setState({
      filteredVehicles: filteredVehicles,
      filterVehiclesLoaded: true
    })
  }

  closeSnack = () => {
    this.setState({
      snackMessage: '',
      snackSeverity: ''
    })
  }

  render() {
    const views = [
      <QuoteOrderForm orderID={this.state.orderID} />,
      <DispatchOrderForm
        orderID={this.state.orderID}
        totalRevenue={this.state.totalRevenue}
      />,
    ];

    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? String(row[id])
          .toLowerCase()
          .includes(filter.value.toLowerCase())
        : true;
    }

    if (this.state.orderData) {
      if (this.state.orderData.id && !this.state.crxDataLoaded) {
        // this.getCRXOrder()
      }
    }

    try {
      if (this.state.orderData) {
        if (this.state.orderData.pickUpDriver && !this.state.pickUpDriverContactLoaded) {
          // console.log("next3")
  
          this.loadPickUpDriverContact(this.state.orderData.pickUpDriver.id);
  
          console.log('loading driver pickup contact data');
        }
      }
    } catch (err) {
      console.log(err);
    }

    if (this.state.pickUpDriverContact) {
      console.log("pick up driver " + this.state.pickUpDriverContact.truckNumber)
    }

    if (this.state.pickUpDriverContact && !this.state.ktLoaded) {
      this.loadKeepTruckin()
    }

    if (this.state.pickUpDriverContact && this.state.vehiclesReady && !this.state.filterVehiclesLoaded) {
      this.filterVehicles()
    }

    console.log(this.state)

    return this.state.loaded && this.state.index !== null ? (
      <React.Fragment justify="center">
        <GridContainer justify="center">
          <GridItem xs={11}>
            {((this.state.coordinates.origin ||
              this.state.coordinates.destination)) && (
                <ShipFullScreenMap
                  originCoords={this.state.coordinates.origin}
                  destinationCoords={this.state.coordinates.destination}
                  driverCoords={(this.state.orderData.status != "Delivered" && this.state.orderData.status != "Docked") && this.state.coordinates.driver}
                  vehicles={(this.state.orderData.status != "Delivered" && this.state.orderData.status != "Docked") && this.state.filteredVehicles}
                />
              )}
            <br />
          </GridItem>
        </GridContainer>
        <GridContainer style={{ marginBottom: '20px', padding: 'auto' }}>
          <GridItem xs={12}>
            <Link to={`/trips/create/${this.state.orderID}`}>
              <Button color="success">CREATE TRIP</Button>
            </Link>
            <Link
              to={{
                pathname: `/ship/${this.state.orderID}`,
                state: {
                  orderData: [this.state.orderData],
                },
              }}
            >
              <Button color="primary">CLONE ORDER</Button>
            </Link>
            <Button color="primary" onClick={this.getTracker}>TRACKING LINK</Button>
          </GridItem>
        </GridContainer>

        {views[this.state.index]}

        <Grid
          container
          justify="center"
          style={{ margin: 'auto', padding: 'auto' }}
        >
          <Grid item xs={11}>
            <Grid container>
              {/* <Modal
                open={this.state.chatOpen}
                onClose={this.chatClose}
                style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}
              >

                <Chat
                  orderID={this.state.orderID}
                  channel='dispatch'
                />


              </Modal> */}

              <GridItem xs={12} md={4}>
                <TaskCreator
                  classes={this.props.classes}
                  orderID={this.state.orderID}
                  freightBillNumber={this.state.orderData.freightBillNumber}
                />
              </GridItem>
              <Modal
                open={this.state.summaryModal}
                onClose={this.summaryModalClose}
              >
                <GridContainer xs={12}>
                  <QuoteSummary />
                </GridContainer>
              </Modal>
            </Grid>
          </Grid>
          <Grid item xs={11}>
            {this.props.user.dataLoaded && (
              <TaskViewer onOrderPage={true} orderID={this.state.orderID} />
            )}
          </Grid>
          <Grid item xs={12} style={{ marginTop: 15, marginBottom: 15 }}>
            <Divider variant="fullWidth" orientation="horizontal" />
          </Grid>
          <Grid container xs={12}>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                style={{ textAlign: 'center', marginTop: 15 }}
              >
                <u>INTERNAL CHAT</u>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Chat orderID={this.state.orderID} channel="dispatch" />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Divider variant="fullWidth" orientation="horizontal" />
          </Grid>
          <Button
            color="primary"
            fullWidth
            onClick={() => this.refreshFinancials()}
          >
            refresh
          </Button>
          <GridContainer xs={12} style={{ marginTop: '20px' }}>
            <GridItem xs={9}>
              <h2>Order Register</h2>
            </GridItem>

            <GridItem
              xs={3}
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Button
                style={{
                  height: '50px',
                  width: '100px',
                }}
                color="primary"
                onClick={this.addEstimatedItemOpen}
              >
                ADD ITEM
              </Button>
            </GridItem>
            <Grid item xs={12}>
              <Collapse in={this.state.addEstimatedItemModal}>
                <Grid item>
                  <EntryForm orderID={this.state.orderID} isActual={false} />
                </Grid>
              </Collapse>
            </Grid>

            <GridItem xs={12}>
              {this.state.registerData && (
                <ReactTable
                  data={this.state.registerData}
                  filterable
                  defaultFilterMethod={filterCaseInsensitive}
                  columns={registryColumns}
                  defaultPageSize={10}
                  style={{
                    color: '#000',
                  }}
                  className="-striped -highlight"
                />
              )}
            </GridItem>
          </GridContainer>
          <GridItem xs={11}>
            <p>
              <b>Total Estimated Revenue:</b>{' '}
              ${((this.state.totalRevenue * 100) / 100).toFixed(2)}
            </p>
            <p>
              <b>Total Estimated Expenses:</b>{' '}
              ${((this.state.totalExpenses * 100) / 100).toFixed(2)}
            </p>
            <p>
              <b>Estimated CM$:</b> ${((this.state.cmTotal * 100) / 100).toFixed(2)}
            </p>
            <p>
              <b>Estimated CM%:</b> {(this.state.cmPercent * 100).toFixed(2)}%
            </p>
          </GridItem>

          <GridContainer xs={12} style={{ marginTop: '20px' }}>
            <GridItem xs={9}>
              <h2>Payments/Receipts Register</h2>
            </GridItem>

            <GridItem
              xs={3}
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Button
                style={{
                  height: '50px',
                  width: '100px',
                }}
                color="primary"
                onClick={this.addActualItemOpen}
              >
                ADD ITEM
              </Button>
            </GridItem>
            <Grid item xs={12}>
              <Collapse in={this.state.addActualItemModal}>
                <Grid item>
                  <EntryForm orderID={this.state.orderID} isActual={true} />
                </Grid>
              </Collapse>
            </Grid>

            <GridItem xs={12}>
              {this.state.paymentsRegisterData && (
                <ReactTable
                  data={this.state.paymentsRegisterData}
                  filterable
                  defaultFilterMethod={filterCaseInsensitive}
                  columns={paymentRegistryColumns}
                  defaultPageSize={10}
                  style={{
                    color: '#000',
                  }}
                  className="-striped -highlight"
                />
              )}
            </GridItem>
          </GridContainer>

          <GridItem xs={11}>
            <p>
              <b>Total Actual Revenue:</b>{' '}
              ${((this.state.actualTotalRevenue * 100) / 100).toFixed(2)}
            </p>
            <p>
              <b>Total Actual Expenses:</b>{' '}
              ${((this.state.actualTotalExpenses * 100) / 100).toFixed(2)}
            </p>
            <p>
              <b>Actual CM$:</b> ${((this.state.actualCmTotal * 100) / 100).toFixed(2)}
            </p>
            <p>
              <b>Actual CM%:</b> {(this.state.actualCmPercent * 100).toFixed(2)}%
            </p>
          </GridItem>
          <GridItem xs={12}>
            <Divider variant="fullWidth" orientation="horizontal" />
          </GridItem>
          <GridItem xs={11}>
            <p>
              <b>Total Revenue Variance:</b>{' '}
              ${(((this.state.actualTotalRevenue * 100) / 100) - ((this.state.totalRevenue * 100) / 100)).toFixed(2)}
            </p>
            <p>
              <b>Total Expenses Variance:</b>{' '}
              ${(((this.state.actualTotalExpenses * 100) / 100) - ((this.state.totalExpenses * 100) / 100)).toFixed(2)}
            </p>
            <p>
              <b>CM$ Variance:</b> ${(((this.state.actualCmTotal * 100) / 100) - ((this.state.cmTotal * 100) / 100)).toFixed(2)}
            </p>
            <p>
              <b>CM% Variance:</b> {((this.state.actualCmPercent * 100).toFixed(2)) - ((this.state.cmPercent * 100).toFixed(2))}%
            </p>
          </GridItem>
          <GridItem xs={12}>
            <Divider variant="fullWidth" orientation="horizontal" />
          </GridItem>

                  {console.log(this.state.tripsData)}
          <GridItem xs={11}>
            <h2>Trips</h2>
            {this.state.tripsData && (
              <ReactTable
                data={this.state.tripsData}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                columns={tripColumns}
                defaultPageSize={10}
                style={{
                  color: '#000',
                }}
                className="-striped -highlight"
              />
            )}
          </GridItem>
{console.log(this.state.orderData.settlements)}
          <GridItem xs={11}>
            <h2>Settlements</h2>
            {this.state.tripsData && (
              <ReactTable
                data={this.state.orderData.settlements}
                filterable
                defaultFilterMethod={filterCaseInsensitive}
                columns={settlementColumns}
                defaultPageSize={10}
                style={{
                  color: '#000',
                }}
                className="-striped -highlight"
              />
            )}
          </GridItem>

          <GridItem xs={12}>
            <Divider variant="fullWidth" orientation="horizontal" />
          </GridItem>

          <GridItem xs={11}>
            <h2>Status Log</h2>
            {this.state.statusLogsData &&
              this.state.statusLogsData.map((statusLog) => {
                let statusTime = statusLog.updatedAt.toDate();
                return (
                  <Card>
                    <CardBody>
                      <GridContainer>
                        <GridItem xs={12}>
                          Status: {statusLog.status}
                          <br />
                          Trip#: {statusLog.trip}
                          <br />
                          By: {statusLog.updatedBy.name}
                          <br />
                          At: {String(statusTime)}
                        </GridItem>
                      </GridContainer>
                    </CardBody>
                  </Card>
                );
              })}
          </GridItem>
          {/* <GridItem>
            <Button color='primary' onClick={this.moveTrips}>MOVE TRIPS AND STUFF</Button>
          </GridItem> */}
        </Grid>
        <Snackbar
          open={Boolean(this.state.snackMessage)}
          autoHideDuration={6000}
          onClose={this.closeSnack}
        >
          <Alert
            onClose={this.closeSnack}
            severity={this.state.snackSeverity}
          >
            {this.state.snackMessage}
          </Alert>
        </Snackbar>
        <Dialog
          style={{ height: 'auto' }}
          open={this.state.editRegistry}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="registry-modal-slide-title"
          aria-describedby="registry-modal-slide-description"
        >
          <DialogTitle>Edit Entry</DialogTitle>
          <DialogContent>
            <EntryForm
              orderID={this.state.orderID}
              isModal={true}
              registry={this.state.registry}
              isActual={false}
              closeModal={this.handleClose}
            />
          </DialogContent>
        </Dialog>
        <Dialog
          style={{ height: 'auto' }}
          open={this.state.editPaymentsRegistry}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handlePaymentsClose}
          aria-labelledby="registry-modal-slide-title"
          aria-describedby="registry-modal-slide-description"
        >
          <DialogTitle>Edit Entry</DialogTitle>
          <DialogContent>
            <EntryForm
              orderID={this.state.orderID}
              isModal={true}
              registry={this.state.paymentsRegistry}
              isActual={true}
              closeModal={this.handleClose}
            />
          </DialogContent>
        </Dialog>
      </React.Fragment>
    ) : (
      <p>Loading...</p>
    );
  }
}
// ok
const mapStateToProps = (state, ownProps) => {
  //console.log(state)
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    // orderID: ownProps.match.params.id
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(styles)
)(OrderDistinction);



// WEBPACK FOOTER //
// ./src/views/Orders/OrdersDetails.jsx